import { BaseRestResource } from "src/app/infrastructure/BaseRestResource";
import httpResource from "src/app/modules/core/infrastructure/httpResource";

class ECommerceSmsResource extends BaseRestResource {
    constructor() {
        super(httpResource, 'public/ecommerce/sms');
    }
}

const eCommerceSmsResource = new ECommerceSmsResource();

export default eCommerceSmsResource;
